import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import toast, { Toaster } from 'react-hot-toast';

const ContactForm = () => {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

emailjs
  .sendForm(
    'service_wi2zsn8',
    'maacform', // Asegúrate de usar este ID (el de tu captura) o el real
    formRef.current,
    'uDn8BDDQoU4wkBGIT'
  )
     .then(
  (result) => {
    toast.success('¡Mensaje enviado con éxito!');
    formRef.current.reset();
  },
  (error) => {
    console.error("ERROR DETALLADO:", error); // <-- ESTO TE DIRÁ QUÉ ESTÁ MAL
    toast.error('Error al enviar: ' + (error.text || 'Revisa la consola'));
  }
)
  };

  return (
    <section className="py-20 px-6 bg-white">
      <Toaster position="top-right" />
      <div className="max-w-xl mx-auto">
        <h2 className="text-3xl font-bold text-slate-900 mb-8 text-center">Contacto</h2>
        
        <form ref={formRef} onSubmit={sendEmail} className="space-y-6">
          <div>
            <input 
              type="text" 
              name="nombre" 
              placeholder="Tu nombre" 
              required 
              className="w-full p-4 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
            />
          </div>
          <div>
            <input 
              type="email" 
              name="email" 
              placeholder="Tu correo electrónico" 
              required 
              className="w-full p-4 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all"
            />
          </div>
          <div>
            <textarea 
              name="mensaje" 
              placeholder="¿En qué podemos ayudarte?" 
              rows="5" 
              required 
              className="w-full p-4 border border-slate-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none transition-all resize-none"
            />
          </div>
          
          <button 
            type="submit" 
            disabled={isSubmitting}
            className="w-full bg-slate-900 text-white font-bold py-4 rounded-xl hover:bg-slate-800 transition-all disabled:opacity-50"
          >
            {isSubmitting ? 'Enviando...' : 'Enviar mensaje'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
